import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getTenantByUserLeaseId: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/tenants/userLeases/:userLeaseId`
    },
    getResidentVehicles: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/tenants/userLeases/:userLeaseId/vehicles`,
        isArray: true
    },
    createResidentVehicle: {
        method: 'POST',
        url: `${BASE_PATH_API}/users/tenants/userLeases/:userLeaseId/vehicles`
    },
    editResidentVehicle: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/tenants/userLeases/:userLeaseId/vehicles/:id`
    },
    deleteResidentVehicle: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/users/tenants/userLeases/:userLeaseId/vehicles/:id`
    },
    updateTenantName: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/tenants/userLeases/:userLeaseId/name`
    },
    updateTenantMoveInDate: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/tenants/userLeases/:userLeaseId/moveIn`
    },
    updateTenantContactInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/tenants/userLeases/:userLeaseId/contactInfo`
    },
    updateTenantPersonalInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/tenants/userLeases/:userLeaseId/personalInfo`
    },
    updateTenantEmergencyContactInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/tenants/userLeases/:userLeaseId/emergencyContactInfo`
    },
    deleteTenant: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/users/tenants/leases/:leaseId/tenant/:id`
    },
    getTenantApplication: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/tenants/userLeases/:userLeaseId/application`
    },
    getTenantLeases: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/tenants/userLeases/:userLeaseId/leases`
    },
    updateResidentAftInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/tenants/:tenantId/aftInfo`
    },
    getTenants: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/tenants`,
        params: {
            '$count': true
        }
    },
    getTenantAdoptionStatistics: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/tenants/adoptionStatistics`
    },
    doesTenantExist: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/tenants/exists`
    },
    doesProspectiveTenantExist: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/tenants/prospectiveTenant`
    }
};

export function TenantsApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getTenantsExportUrl = function getTenantsExportUrl(params) {
        return `${BASE_PATH_API}/users/tenants/export?${$httpParamSerializer(params)}`;
    };

    return service;
}
TenantsApi.$inject = [
    '$httpParamSerializer'
];
